import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateGroupNameParams {
  groupId: string;
  name: string;
}

export interface IUpdateGroupNameResult {
}

export class UpdateGroupNameRequest extends Request<IUpdateGroupNameParams, IUpdateGroupNameResult> {
  constructor(params: IUpdateGroupNameParams) {
    super('updateGroupName', params);
  }
}
